var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriestLeftLegBtm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 45,
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 38,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 38,
    width: 1,
    height: 1,
    fill: "#B0AC89"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 38,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 38,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 39,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 39,
    width: 1,
    height: 1,
    fill: "#B0AC89"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 39,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 39,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 40,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 40,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 40,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 41,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 41,
    width: 1,
    height: 1,
    fill: "#B0AC89"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 41,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 41,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 42,
    width: 1,
    height: 1,
    fill: "#70664B"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 42,
    width: 1,
    height: 1,
    fill: "#C5BFA7"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 42,
    width: 1,
    height: 1,
    fill: "#70664B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriestLeftLegBtm);
export default __webpack_public_path__ + "static/media/priest-LeftLegBtm.c82bc83453204d64c50d123cc6814d33.svg";
export { ForwardRef as ReactComponent };